import { render, staticRenderFns } from "./btn-module.vue?vue&type=template&id=4d923cc4&scoped=true&"
import script from "./btn-module.vue?vue&type=script&lang=js&"
export * from "./btn-module.vue?vue&type=script&lang=js&"
import style0 from "./btn-module.vue?vue&type=style&index=0&id=4d923cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d923cc4",
  null
  
)

export default component.exports